/* ==========================================================================
   VYLNS — Cart
   Drawer open/close, optimistic quantity changes, upsell adds, and a free
   shipping bar that recalculates on every mutation.
   All cart HTML is re-rendered server-side through the Section Rendering API,
   so Liquid stays the single source of truth for markup and money formatting.
   ========================================================================== */
(function () {
  'use strict';

  var SECTION = 'vylns-cart-drawer';

  function drawer() { return document.getElementById('v-cart-drawer'); }

  function open() {
    var d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* Re-render the drawer and any cart-page section from the server. */
  function refresh(shouldOpen) {
    return fetch(window.Shopify.routes.root + '?section_id=' + SECTION)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#v-cart-drawer');
        var d = drawer();
        if (fresh && d) {
          var wasOpen = d.classList.contains('is-open');
          d.innerHTML = fresh.innerHTML;
          bind();
          if (wasOpen || shouldOpen) open();
        }
        return fetch(window.Shopify.routes.root + 'cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-v-cart-count]').forEach(function (n) {
          n.textContent = cart.item_count;
        });
        // Cart page lives in its own section — reload it rather than patching.
        if (document.querySelector('[data-v-cart-page]')) window.location.reload();
        return cart;
      });
  }

  function change(line, quantity) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function () { return refresh(false); });
  }

  function bind() {
    var root = document;

    root.querySelectorAll('[data-v-cart-open]').forEach(function (b) {
      if (b._bound) return;
      b._bound = true;
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });

    root.querySelectorAll('[data-v-cart-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    /* Quantity steppers — optimistic UI, then reconcile with the server. */
    root.querySelectorAll('[data-v-line-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.dataset.vLine, 10);
        var input = btn.closest('.v-li__qty').querySelector('input');
        var next = Math.max(0, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.vLineQty, 10));
        input.value = next;
        change(line, next);
      });
    });

    root.querySelectorAll('[data-v-line-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        change(parseInt(input.dataset.vLineInput, 10), Math.max(0, parseInt(input.value, 10) || 0));
      });
    });

    root.querySelectorAll('[data-v-line-remove]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        change(parseInt(a.dataset.vLineRemove, 10), 0);
      });
    });

    /* Cart upsell adds */
    root.querySelectorAll('[data-v-cart-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var label = btn.textContent;
        btn.disabled = true;
        btn.textContent = '…';
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.vCartAdd, 10), quantity: 1 }] })
        })
          .then(function () { return refresh(false); })
          .then(function () { btn.disabled = false; btn.textContent = label; })
          .catch(function () { btn.disabled = false; btn.textContent = label; });
      });
    });
  }

  /* Intercept every add-to-cart form so the drawer opens instead of the page
     navigating to /cart — keeps the shopper in the browse flow. */
  function interceptForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json(); })
        .then(function () { return refresh(true); })
        .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } })
        .catch(function () { form.submit(); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bind();
    interceptForms();
  });
  document.addEventListener('shopify:section:load', bind);
})();
